import { gql } from '__generated__';

export default gql(`
  mutation Unsubscribe($email: String!, $token: String!, $types: [MailOptOutType!]!) {
    unsubscribe(email: $email, token: $token, types: $types)
  }
`);
